// extracted by mini-css-extract-plugin
export default {"termsOfUse":"legal_termsOfUse__KvL-7","link":"legal_link__kKvr7"};